import React from 'react';
import { Box, Typography } from '@mui/material';

type AppErrorBoundaryState = {
    hasError: boolean;
};

class AppErrorBoundary extends React.Component<
    { children: React.ReactNode },
    AppErrorBoundaryState
> {
    state: AppErrorBoundaryState = { hasError: false };

    static getDerivedStateFromError(): AppErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: unknown) {
        console.error('App render failed', error);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box sx={{ p: 4 }}>
                    <Typography variant="h5" gutterBottom>
                        Something went wrong
                    </Typography>
                    <Typography variant="body1">
                        Refresh the page. If this is the admin sign-in, try Continue as local admin
                        after refresh.
                    </Typography>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default AppErrorBoundary;
